import Vue from "vue";
import { modelServices } from "../../scripts/ah.mb.ui.model-services"
import { ReportServices } from "../../scripts/ah.mb.report-services";
import { ModelNotifier } from "../../scripts/model-notifier";
import { Watch, Component, Prop } from "vue-property-decorator";
import { Action } from "vuex-class";
import { IDashboardPublishDefinition } from "../../scripts/dashboardServices";
import { PageType, RecentlyVisitedPages } from "../../scripts/common/ah.mb.common.stored-stack";

//import { embedDashboard } from 'amazon-quicksight-embedding-sdk';

const namespace: string = "profile";

@Component
export default class Dashboard extends Vue {

    @Prop()
    modelId: string;

    @Action("setCurrentModelId", { namespace: namespace }) setCurrentModelId: any;


    // Model change observer
    private modelObserver = new ModelNotifier();

    modelServices = new modelServices(this.modelObserver);
    reportServices = new ReportServices(this.modelObserver);

    // Dashboard stuf
    private showPublishToDashboardDialog = false;
    publishToDashboardModel: IDashboardPublishDefinition = {
        name: "", modelId: "", exports: [], /*nodePathAndName: "", format: "JSON", query: "", resultType: "Report Results",*/
        setName: "", customFieldDefs:[]
    };

    @Watch("$route.params.modelId")
    routeModeIdChanged(newVal) {
        this.loadModel();
    }

    loadModel() {
        this.setCurrentModelId(this.modelId);

        // Add page to recent list
        if (this.modelId) {
            const recentItemsStore = new RecentlyVisitedPages();
            recentItemsStore.stack.add(
                {
                    modelId: this.modelId,
                    pageType: PageType.Dashboard,
                    name: this.modelId + " | Dashboard",
                    visitedDate: new Date()
                });

        }
    }



    mounted() {
        this.loadModel();

        //var options = {
        //    url: "https://us-east-1.quicksight.aws.amazon.com/sn/dashboards/dashboardId?isauthcode=true&identityprovider=quicksight&code=authcode",
        //    container: document.getElementById("dashboardContainer"),
        //    parameters: {
        //        country: "United States",
        //    states: [
        //            "California",
        //            "Washington"
        //        ]
        //    },
        //    scrolling: "no",
        //    height: "700px",
        //    width: "1000px",
        //    locale: "en-US",
        //    footerPaddingEnabled: true
        //};
        //const dashboard = embedDashboard(options);
    }

    tabChanged(tabName: "tools" | "viewer") {

    }


    publishToDashboard() {

        this.publishToDashboardModel = {
            //format: "JSON",
            //nodePathAndName: "",
            //query: "",
            name: "",
            modelId: this.modelId,
            setName: "",
            exports: [],
            customFieldDefs: []
            //resultType: "Report Results"
        }
        this.showPublishToDashboardDialog = true;
    }

    onPublishToDashboardDialogClosed() {
        this.showPublishToDashboardDialog = false;
    }


}



// WEBPACK FOOTER //
// ./ClientApp/components/dashboard/dashboard.ts